import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Environment } from '@environments/interface.environment';
import { CUSTOMERENVIRONMENT, WINDOW } from '@app/common/app-tokens';
import { CacheService } from '@app/services/cache.service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PlatformLocation } from '@angular/common';
import { GITVERSION } from '@environments/git-version';
import { Utilities } from './common/utilities';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  private subscriptions = new Subscription();
  private cacheKey = 'AppComponent-Current-Path';
  shouldLoadMainComponent = true;

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: Environment,
    private cacheService: CacheService,
    private router: Router,
    private platformLocation: PlatformLocation,
    @Inject(WINDOW) private window: Window, ) {



    if (!this.inIframe()) {
       this.clearCacheIfAppWasUpdated();
       this.shouldLoadMainComponent = Utilities.shouldLoadMain(this.window);
    }
  }

  private clearCacheIfAppWasUpdated() {
    // Get currently stored version from cache
    const currentStoredVersion = this.cacheService.get<any>(GITVERSION.hash);
    if (!currentStoredVersion) {
      // If we dont have an entry for the stored version we set the current version.
      this.cacheService.clearPersistentCache();
      this.cacheService.set<any>(GITVERSION.hash, GITVERSION);
    } else {
      // If we have an entry for the version we compare it to the current version
      if (GITVERSION.hash !== currentStoredVersion.hash) {
        // If the current version differs from the stored version we clear the cache update the entry with the current version
        this.cacheService.clearPersistentCache();
        this.cacheService.set<any>(GITVERSION.hash, GITVERSION);
      } else {
        this.cacheService.removeAllExpiredItemsInPersistentCache();
      }
    }
  }

  inIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  ngOnInit(): void {
    if (!this.inIframe()) {
      this.subscriptions.add(
        this.router.events
          .pipe(filter(event => event instanceof NavigationEnd))
          .subscribe((event: NavigationEnd) => {
            window.scrollTo(0, 0);
          })
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
